import { useAppSelector } from 'hooks/redux';
import React from 'react';
import { Outlet } from 'react-router-dom';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

import NavigateSetter from 'NavigateSetter';
import { ConnectionStatusProvider } from 'components/ConnectionStatus';
import { StandardDrawerEdgeProvider } from 'components/Drawers/StandardDrawer';
import ErrorBoundary from 'components/ErrorBoundary';
import RootModal from 'components/RootModal';
import { RootTooltipHost } from 'components/RootTooltip';
import VersionDisplay from 'containers/App/VersionDisplay';
import Maintenance from 'containers/Maintenance';
import OfflinePage from 'containers/OfflinePage';
import ServiceWorkers from 'containers/ServiceWorkers';
import GlobalHotKeys from 'containers/GlobalHotKeys';
import PrivacyModeHotKeys from 'containers/PrivacyModeHotKeys';
import AppearanceHotKeys from 'containers/AppearanceHotKeys';
import RefreshHotKeys from 'containers/RefreshHotKeys';
import LaunchDarkly from 'utils/LaunchDarkly';

import { useShowOfflinePage } from './useShowOfflinePage';

///////////////////////////////////////////////////////////////////////////////////////////////////////////////
import DevMenuInternal from 'containers/App/DevMenu';
/////////

let DevMenu: any;
DevMenu = null;
///////////////////////////////////////////////////////////////////////////////////////////////////////////////
DevMenu = DevMenuInternal;
/////////

const LayoutLoggedOut = () => {
  const showOfflinePage = useShowOfflinePage();
  const isMaintenance = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'maintenance'));
  const dev = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'dev'));

  if (showOfflinePage) {
    return (
      <ErrorBoundary>
        <OfflinePage />
      </ErrorBoundary>
    );
  }

  return (
    <ConnectionStatusProvider>
      <StandardDrawerEdgeProvider>
        {isMaintenance ? (
          <ErrorBoundary>
            <Maintenance />
          </ErrorBoundary>
        ) : (
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        )}

        <ErrorBoundary>
          <VersionDisplay />
        </ErrorBoundary>

        <ErrorBoundary>
          <RootModal />
        </ErrorBoundary>

        <ErrorBoundary>
          <RootTooltipHost />
        </ErrorBoundary>

        <ErrorBoundary>
          {/*
         // @ts-expect-error FIXME TS2741 */}
          <NavigateSetter />
        </ErrorBoundary>

        <ErrorBoundary>
          <ServiceWorkers />
        </ErrorBoundary>

        <React.StrictMode>
          <ErrorBoundary>{dev && DevMenu && <DevMenu />}</ErrorBoundary>
        </React.StrictMode>

        <ErrorBoundary>
          <LaunchDarkly />
        </ErrorBoundary>

        <ErrorBoundary>
          <GlobalHotKeys />
          <PrivacyModeHotKeys />
          <AppearanceHotKeys />
          <RefreshHotKeys />
        </ErrorBoundary>
      </StandardDrawerEdgeProvider>
    </ConnectionStatusProvider>
  );
};

export default LayoutLoggedOut;
